<template>

  <div class="row newsContent" v-if="showContent">
    <div class="col-md-3">
      <ul class="category-list">
        <li>
          <router-link to="/noticias">
            Todas
          </router-link>
        </li>
        <li v-for="category in categories">
          <router-link :to="getUrlCategory(category.id, category.name)">
            {{ category.name }}
          </router-link>
        </li>
      </ul>
    </div>

    <div class="col-md-9">
      <h3 class="titulo">{{ title }}</h3>
      <p v-html="getContent" class="texto">
      </p>
      <comentarios v-show="item.comments" :comments="item.comentarios" :tipo="tipo" :referencia="item.id"></comentarios>

      <div class="socialShare">
        <span> Clique e compartilhe: </span>
        <social-sharing :url="currentUrl"
                        :quote="title"
                        inline-template>
          <div>
            <network network="facebook">
              <i class="fab fa-facebook-f"></i>
            </network>
            <network network="googleplus">
              <i class="fab fa-google-plus-g" aria-hidden="true"></i>
            </network>
            <network network="twitter">
              <i class="fab fa-twitter" aria-hidden="true"></i>
            </network>
          </div>
        </social-sharing>
      </div>

    </div>
  </div>
</template>
<style>
  .noticia-content {
    overflow: hidden;
    position: relative;
    width: 100%;
    min-height: 50px;
  }

  .newsContent .image img {
    display: block;
    margin: 0 auto;
  }
</style>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';
  import SocialSharing from 'vue-social-sharing'
  import Comentarios from '../views/Comentarios'

  export default {
    components: {
      Comentarios,
      Loading,
      SocialSharing
    },
    data() {
      return {
        tipo:'noticia',
        item: {
          id:'',
          title: '',
          image: '',
          date: '',
          description: '',
          comentarios: [],
          categoria: '',
          categorias_id: '',
        },
        title: '',
        categories: [],
        showContent: false,
        currentUrl: ''
      }
    },
    activated() {
      let self = this;
      self.showContent = false;
      get('news/' + this.$route.params.id).then(function (response) {
        let news = response.data.result.data;
        self.item.id = news.id;
        self.title = news.name;
        self.item.title = news.name;
        self.item.comments = news.comments;
        self.item.description = news.descricao;
        self.item.comentarios = news.comentarios;
        self.item.date = news.date;
        self.item.image = news.imagem;
        self.item.categoria = news.categoria.name;
        self.item.categorias_id = news.categorias_id;
        self.showContent = true;
      });
    },
    computed: {
      getTitle: function () {
        return this.title;
      },
      getContent: function () {

        if (this.item.image) {
          var date = '<span class="date"> '+this.item.date+' em '+ this.item.categoria+' </span>';
          var imagem = '<img src="' + this.item.image + '" class="image"/>';
          var content = imagem + date + "  " + this.item.description;
          return content;
        }
        return this.item.description
      }
    },
    mounted() {
      let self = this;
      get('categories-news').then(function (response) {
        self.categories = response.data.result.data;
      });

      this.currentUrl = window.location.href;
      get('news/' + this.$route.params.id).then(function (response) {
        let news = response.data.result.data;
        self.title = news.name;
        self.item.title = news.name;
        self.item.description = news.descricao;
        self.item.date = news.date;
        self.item.image = news.imagem;
        self.item.categoria = news.categoria.name;
        self.item.categorias_id = news.categorias_id;
        self.showContent = true;
      });
    },

    methods: {
      getUrlCategory(id, string) {
        return '/noticias/' + id + '/' + slugify(string);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/BlogShow.vue